#import "../fragments/dashboard-stats-fragment.graphql"

query GetFormsDashboard($input: DashboardInput!) {
    formsDashboard(input: $input) {
        stats {
            ...DashboardStatsFragment
        }
        numForms
        topForms {
            form {
                id
                name
                htmlUrlPath
            }
            views
            submissions
        }
    }
}
